export default angular
  .module('st.Integrations.PriceFinder', [])
  .service('priceFinderService', ($http, dataService, PRICE_FINDER) => ({
    authenticate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PRICE_FINDER.API.AUTHENTICATE,
        { params }
      ),
    deauthenticate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PRICE_FINDER.API.DEAUTHENTICATE,
        { params }
      ),
    propertyDetails: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PRICE_FINDER.API.PROPERTY_DETAILS,
        { params }
      ),
    propertyEventSubscribe: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PRICE_FINDER.API.PROPERTY_EVENT_SUBSCRIBE,
        { params }
      ),
    propertyReport: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PRICE_FINDER.API.PROPERTY_REPORT,
        { params }
      ),
    propertySearch: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PRICE_FINDER.API.PROPERTY_SEARCH,
        {
          params
        }
      ),
    propertyUrl: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PRICE_FINDER.API.PROPERTY_URL,
        {
          params
        }
      )
  }))
  .constant('PRICE_FINDER', {
    API: {
      AUTHENTICATE: '/api/v1/integrations/price-finder/authenticate',
      DEAUTHENTICATE: '/api/v1/integrations/price-finder/deauthenticate',
      PROPERTY_DETAILS: '/api/v1/integrations/price-finder/property-details',
      PROPERTY_EVENT_SUBSCRIBE: '/api/v1/integrations/price-finder/property-event-subscribe',
      PROPERTY_REPORT: '/api/v1/integrations/price-finder/property-report',
      PROPERTY_SEARCH: '/api/v1/integrations/price-finder/property-search',
      PROPERTY_URL: '/api/v1/integrations/price-finder/property-url'
    }
  });
